import { useEffect, useState } from "react";
import { ethers } from "ethers";
import nftAbi from "../abis/RockNFT.json";
import marketplaceAbi from "../abis/NFTMarketplace.json";
import "./NFTCard.css";

const MARKETPLACE_ADDRESS = "0x0cCC053bA17A822e073A8F4c057a23922ee0B161";

function NFTCard({ nftAddress, tokenId, startPrice, highestBid, buyNowPrice, deadline, signer }) {
  const [image, setImage] = useState("");
  const [timeLeft, setTimeLeft] = useState("");
  const [bidAmount, setBidAmount] = useState("");

  useEffect(() => {
    const fetchMetadata = async () => {
      const nft = new ethers.Contract(nftAddress, nftAbi.abi, signer);
      const tokenUri = await nft.tokenURI(tokenId);
      const httpUri = tokenUri.replace("ipfs://", "https://ipfs.io/ipfs/");
      const response = await fetch(httpUri);
      const metadata = await response.json();
      const imageUri = metadata.image.replace("ipfs://", "https://ipfs.io/ipfs/");
      setImage(imageUri);
    };

    fetchMetadata();

    const interval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      const diff = deadline - now;
      if (diff <= 0) {
        setTimeLeft("경매 종료");
      } else {
        const min = Math.floor(diff / 60);
        const sec = diff % 60;
        setTimeLeft(`${min}분 ${sec}초`);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [nftAddress, tokenId, signer, deadline]);

  const handleFinalize = async () => {
    try {
      const marketplace = new ethers.Contract(MARKETPLACE_ADDRESS, marketplaceAbi.abi, signer);
      await marketplace.finalizeAuction(nftAddress, tokenId);
      alert("✅ NFT 정산 완료 (돌려받거나 낙찰자에게 전송)");
    } catch (error) {
      console.error(error);
      alert("❌ 실패: " + error.message);
    }
  };

  const handleBid = async () => {
    try {
      const bidValue = ethers.parseEther(bidAmount);
      const buyNowValue = ethers.parseEther(buyNowPrice);

      const marketplace = new ethers.Contract(MARKETPLACE_ADDRESS, marketplaceAbi.abi, signer);

      if (bidValue < buyNowValue) {
        await marketplace.placeBid(nftAddress, tokenId, { value: bidValue });
        alert("✅ 입찰 성공!");
      } else if (bidValue === buyNowValue) {
        await marketplace.buyNow(nftAddress, tokenId, { value: bidValue });
        alert("✅ 즉시 구매 성공!");
      } else {
        alert("❌ 입찰 금액은 즉시 구매가를 초과할 수 없습니다.");
      }
    } catch (error) {
      console.error(error);
      alert("❌ 입찰 실패: " + error.message);
    }
  };

  const isAuctionEnded = timeLeft === "경매 종료";

  return (
    <div className={`nft-card ${isAuctionEnded ? "ended" : ""}`}>
      {image && <img src={image} alt={`NFT ${tokenId}`} style={{ width: "100%" }} />}
      <p>Token ID: {tokenId}</p>
      <p>남은 시간: {timeLeft}</p>
      <p>최소 입찰가: {startPrice} KAIA</p>
      <p>현재 입찰가: {highestBid} KAIA</p>
      <p>즉시 구매가: {buyNowPrice} KAIA</p>

      <input
        type="text"
        placeholder="입찰 금액 (KAIA)"
        value={bidAmount}
        onChange={(e) => setBidAmount(e.target.value)}
        style={{ width: "90%", marginTop: "10px" }}
      />
      <button onClick={handleBid} style={{ marginTop: "5px" }} disabled={isAuctionEnded}>
        입찰하기
      </button>

      <button
        onClick={handleFinalize}
        style={{ marginTop: "10px" }}
        disabled={!isAuctionEnded}
      >
        NFT 받기 (경매 종료 시)
      </button>

      {isAuctionEnded && (
        <p style={{ marginTop: "10px", color: "red", fontWeight: "bold" }}>
          경매 종료
        </p>
      )}
    </div>
  );
}

export default NFTCard;
